import { render, staticRenderFns } from "./UMLVOPayment.vue?vue&type=template&id=55491587&scoped=true&"
import script from "./UMLVOPayment.vue?vue&type=script&lang=js&"
export * from "./UMLVOPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55491587",
  null
  
)

export default component.exports